import { createContext } from 'react'

const IM_Context = createContext()

export default IM_Context
